var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoPracticario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77.39 68.35",
    style: {
      enableBackground: "new 0 0 77.39 68.35"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#162E5B;stroke-width:3;}\r\n\t.st1{fill:none;stroke:#162E5B;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.87,4.01c0,0-5.66-5.66-11.31,0l-24.5,24.5c0,0-5.66,5.66,0,11.31l24.5,24.5c0,0,5.66,5.66,11.31,0 l24.5-24.5c0,0,5.66-5.66,0-11.31L48.87,4.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.29,27.86c0,2.48-0.74,4.23-2.23,5.26c-1.48,1.03-4.1,1.54-7.85,1.54h-2.97V21.21h3.12 c3.7,0,6.27,0.51,7.73,1.53C47.57,23.76,48.29,25.46,48.29,27.86z M61.76,37.34c1.09-2.59,1.64-5.6,1.64-9.01 c0-3.21-0.55-6.12-1.66-8.74c-1.11-2.62-2.71-4.8-4.82-6.55c-1.79-1.51-3.98-2.58-6.56-3.21C47.79,9.21,43.31,8.9,36.94,8.9h-4.18 L20.66,21v25.44l14.6,14.6V47.25l2.81,0l2.65,0c4.81,0,8.31-0.27,10.5-0.82c2.19-0.55,4.08-1.45,5.7-2.7 C59.05,42.07,60.67,39.94,61.76,37.34z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 33.58,
    y1: 8.54,
    x2: 6.5,
    y2: 8.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 12.79,
    y1: 15.21,
    x2: 1.5,
    y2: 15.21
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoPracticario);
export default __webpack_public_path__ + "static/media/icono_practicario.cb413a0cc40d37f34df340b759362673.svg";
export { ForwardRef as ReactComponent };